import { CommandResult, FacilityInspectionChangeRecord, InspectionPoint, InspectionPointStatus, InspectionPointUsage, LocationInspectionPointList, SafetyInspection } from '../amorg-common'
import { fileNameHelper } from '../amorg-common';
import { apiPath } from "./../amorg-common";
import { commandAuthWrapper, queryAuthWrapper, rawCommandAuthWrapper } from "./serverApiHelpers";

const safetyInspectionPath = `${apiPath}/safetyinspections`;
const facilityInspectionPath = `${apiPath}/facilityinspections`;

export const getSafetyInspection = async (
    activityId: string
): Promise<SafetyInspection> =>{
    const data = await queryAuthWrapper(`${safetyInspectionPath}/${activityId}`) as SafetyInspection;
    for(const l of data.locations){
        for(const f of l.facilities){
            for(const i of f.inspectionPoints){
                if(i.inspectionResult.initialInspectionDate)
                    i.inspectionResult.initialInspectionDate = new Date(i.inspectionResult.initialInspectionDate);
            }
        }
    }
    return data;
}


export const getAvailableFacilityInspectionPoints = async (
    facilityId:string
): Promise<InspectionPoint[]> =>{
    return await queryAuthWrapper(`${safetyInspectionPath}/facilities/${facilityId}/availableInspectionPoints`);
}

export const getAvailableLocationInspectionPoints = async (): Promise<LocationInspectionPointList[]> =>{
    return await queryAuthWrapper(`${safetyInspectionPath}/locations/availableInspectionPoints`);
}

export const getFacilityInspectionHistory = async (facilityInspectionId:string):Promise<FacilityInspectionChangeRecord[]> =>
{
    const data:FacilityInspectionChangeRecord[] = await queryAuthWrapper(`${facilityInspectionPath}/${facilityInspectionId}/history`);
    return data.map(i => {
        return {
            ...i,
            date: new Date(i.date)
        }
    });
}



export const createFacilityInspection = async (
    activityId:string,
    facilityId: string,
    inspectionPointId:string,
    id: string,
): Promise<CommandResult> =>
    commandAuthWrapper(`${safetyInspectionPath}/${activityId}/facilities/${facilityId}/inspections`, 'POST',
        { inspectionPointId, id });

export const createAllLocationInspections = async (
    activityId: string,
    locationId: string,
): Promise<CommandResult> =>
    commandAuthWrapper(`${safetyInspectionPath}`, 'POST',
        { activityId, locationId });

export const deleteFacilityInspection = async (
    activityId:string,
    id:string
): Promise<CommandResult> => 
    commandAuthWrapper(`${safetyInspectionPath}/${activityId}/inspections/${id}`, 'DELETE');

export const updateFacilityInspection = async (
    activityId:string,
    facilityInspectionId: string,
    status:InspectionPointStatus,
    comment:string
): Promise<CommandResult> =>
    commandAuthWrapper(`${safetyInspectionPath}/${activityId}/inspections/${facilityInspectionId}`, 'PUT',
        { status, comment });

export const uploadInspectionPointImage = async (facilityInspectionId:string, fileHandle:File):Promise<CommandResult> => {
    const formData = new FormData();
    formData.append('uploaded_file', fileHandle);

    const fileName = fileHandle.name;
    const extension = fileNameHelper.getNameSections(fileName).extension;
    const privateFileName = fileNameHelper.generateName(extension);


    return await rawCommandAuthWrapper(`${safetyInspectionPath}/inspections/${facilityInspectionId}/imageFileUpload/${privateFileName}`, 'POST', formData, {});
}

export const deleteInspectionPointImage = async (facilityInspectionId:string, privateFileName:string):Promise<CommandResult> =>
    await commandAuthWrapper(`${safetyInspectionPath}/inspections/${facilityInspectionId}/images/${privateFileName}`, 'DELETE', {});


export const getInspectionPointUsage = async ():Promise<InspectionPointUsage[]> =>
    await queryAuthWrapper(`${safetyInspectionPath}/inspectionPoints`);

export const createInspectionPoint = async (id:string, facilityTypeIds:string[], title:string, instructions:string):Promise<CommandResult> =>
    await commandAuthWrapper(`${safetyInspectionPath}/inspectionPoints/${id}`, 'POST', 
        { 
            config:{facilityTypeIds}, 
            title, 
            instructions 
        });

export const updateInspectionPoint = async (id:string, facilityTypeIds:string[], title:string, instructions:string):Promise<CommandResult> =>
    await commandAuthWrapper(`${safetyInspectionPath}/inspectionPoints/${id}`, 'PUT', 
        { 
            config:{facilityTypeIds}, 
            title, 
            instructions 
        });